import React from 'react';

function UnitButton({ product, isLowestRender, tlord }) {
  const children = (
    <>
      <DealDisamount
        dealDisamount={product.dealDisamount}
        isLowestRender={isLowestRender}
      />
      <span className="text_bar"></span>
      <DeliveryConditionFee
        deliveryConditionFee={product.deliveryConditionFee}
        isLowestRender={isLowestRender}
      />
      {isLowestRender && <span className="label_lowest">최저가</span>}
      {tlord === 1 && <span className="current_product_text">현재상품</span>}
    </>
  );

  return (
    <>
      {tlord === 1 ? (
        <div className="current_product">{children}</div>
      ) : (
        <a
          href={`${TMON.htLocal.htURL.www_m_deals}${product.dealSrl}`}
          className="info_unit_button"
          target="_self"
          data-tlarea="DDSCDL"
          data-tlord={tlord}
        >
          {children}
        </a>
      )}
    </>
  );
}

function DealDisamount({ dealDisamount, isLowestRender = false }) {
  return isLowestRender ? (
    <strong className="text_color1 goods">
      <span className="price">{TMON.util.numberWithComma(dealDisamount)}</span>
      원
    </strong>
  ) : (
    <span className="goods">
      <span className="price">{TMON.util.numberWithComma(dealDisamount)}</span>
      원
    </span>
  );
}

function DeliveryConditionFee({
  deliveryConditionFee,
  isLowestRender = false,
}) {
  return isLowestRender ? (
    <>
      {deliveryConditionFee ? (
        <strong className="text_color1 ship">
          배송비
          <span className="price">
            {` ${TMON.util.numberWithComma(deliveryConditionFee)}`}
          </span>
          원
        </strong>
      ) : (
        <strong className="text_color1 ship">무료배송</strong>
      )}
    </>
  ) : (
    <>
      {deliveryConditionFee ? (
        <span className="ship">
          배송비
          <span className="price">
            {` ${TMON.util.numberWithComma(deliveryConditionFee)}`}
          </span>
          원
        </span>
      ) : (
        <span className="ship">무료배송</span>
      )}
    </>
  );
}

export default UnitButton;
